import { useSelector } from 'react-redux'
import { RootState } from '../../store/modules/rootReducer'
import ContentLoader, { IContentLoaderProps } from 'react-content-loader'

const Loader = (props: IContentLoaderProps) => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode)

  const defaultProps: IContentLoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <ContentLoader {...defaultProps} {...props}>
      {props.children}
    </ContentLoader>
  )
}

export default Loader
